import { render, staticRenderFns } from "./dialogEditcategory.vue?vue&type=template&id=368243cb&lang=html"
import script from "./dialogEditcategory.vue?vue&type=script&lang=js"
export * from "./dialogEditcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports